import { Pipe, PipeTransform } from '@angular/core'; 


@Pipe({   
    name: 'nameShortener'
})

export class NameShortenerPipe implements PipeTransform {   
    
    transform(value: string): string {     
        if (!value) {       
            return '';     
        }     
        const nameArray = value.split(' ');     
        if (nameArray.length === 1) {       
            return nameArray[0].charAt(0).toUpperCase();     
        }     
        
        const initials = nameArray[0].charAt(0) + nameArray[nameArray.length - 1].charAt(0);     
        return initials.toUpperCase();
    } 
}